import Vue from 'vue'
import Router from 'vue-router'
/*PC路由配置*/
import content from '@/page/content'
import index from '@/page/index'
import aboutUs from '@/page/aboutUs'
import sugarControl from '@/page/sugarControl'
import userInfo from '@/page/userInfo'

/*手机路由配置*/
import Hello from '@/components/Hello'
import article from '@/components/article'
import aboutUsHs from '@/components/aboutUsHs'
// import { resolve } from 'dns';

Vue.use(Router)

export default new Router({
  mode: 'history',
  path: '/server',
 routes: [
    // {
    //   path:'/',
    //   redirect:'/index'
    // },
    {
      path: '/content',
      name: 'content',
      component: content
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo
    },
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/Hello',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/article',
      name: 'article',
      component: article
    },
    {
      path: '/aboutUsHs',
      name: 'aboutUsHs',
      component: aboutUsHs
    },
    {
      path: '/sugarControl',
      name: 'sugarControl',
      component: sugarControl
    },
    {
      path: '/ClinicAppointment',
      name: 'ClinicAppointment',
      component: ClinicAppointment => require(['@/page/ClinicAppointment'],ClinicAppointment)
    },
    {
      path: '/footerBottomer',
      name: 'footerBottomer',
      component: footerBottomer => require(['@/page/footerBottomer'],footerBottomer)
    },
    {
      path: '/client',
      name: 'client',
      component: client => require(['@/page/client'],client)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js